import { Time } from '@poseidon/components/StrokeIcons';

import type { SequenceStep } from '~/components/Sequence/sequenceSteps';
import { DEFAULT_WAIT_DAYS, stepLabel } from '~/components/Sequence/sequenceSteps';
import { SequencePillPopover } from '~/components/Sequence/SequencePillPopover';
import { WaitDurationInput, type WaitUnit } from '~/components/Sequence/WaitDurationInput';

interface Props {
  /** The `wait` step. */
  step: SequenceStep;
  /** Shared chip classes (grab cursor, hover shadow, invalid ring) from the node. */
  chipBase: string;
  /** Commit a new wait length + unit. Omit (locked view) → the pill is a static, non-clickable label. */
  onChangeWait?: (days: number, unit: WaitUnit) => void;
}

/**
 * A `wait` step: a compact static pill ("Wait 1 week") that opens its editable duration (number +
 * days/weeks) in a portaled popover on click — see {@link SequencePillPopover}. Read-only (no
 * `onChangeWait`) is just the label.
 */
export function SequenceWaitNode({ step, chipBase, onChangeWait }: Props) {
  return (
    <SequencePillPopover
      icon={<Time.Clock className="size-4 shrink-0 text-lynch-500 dark:text-lynch-400" />}
      label={stepLabel(step)}
      chipBase={chipBase}
      editAriaLabel="Edit wait duration">
      {onChangeWait != null && (
        <WaitDurationInput
          autoFocus
          days={step.waitDays ?? DEFAULT_WAIT_DAYS}
          unit={step.waitUnit ?? 'days'}
          onCommit={onChangeWait}
        />
      )}
    </SequencePillPopover>
  );
}
